import { useTranslation } from "react-i18next";
import Section from "../../Atoms/Section";
import { useEffect, useRef, useState } from "react";
import BlueButton from "../../Atoms/BlueButton";
import * as api from '../../../api';
import Header from "../../Components/SDO24/Header";
import PopA1 from "../../Components/SDO24/Parcours/PopA1";
import Step2 from "../../Components/SDO24/Parcours/Step2";
import { useNavigate } from "react-router-dom";
import { formDataToObject } from "../../Utils/Forms";
import { validateStep1ASDO2024, validateStep2SDO2024 } from "../../Utils/Validator";
import Spinner from "../../../Plateforme/Atoms/Spinner";

const RegisterSDO24popA = (props) => {

    const navigate = useNavigate()

    const [projets, setProjets] = useState([{
        _id: Math.random().toString(36).substr(2, 9),
        userId: null,
        description: '',
        typologie: '',
        savoirfaire: '',
        dp: '',
        dpetai: '',
        da: '',
        précisions: '',
        validated: false
    }]);

    const [deletedProjets, setDeletedProjets] = useState([]);
    const [step, setStep] = useState(1);
    const formRef = useRef(null);
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);

    //parse eid from url and get event
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                setEvent(response.data);
                setLoading(false);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    //scroll to top on step change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step])

    const { i18n } = useTranslation('common');

    function submit(e) {
        e.preventDefault();
        setLoading(true);
        const submission = new FormData(e.target);

        if (!props.fullUser || !props.fullUser.user) {
            alert("Please login to register");
            return;
        }

        if (props.fullUser.user.role === "admin") {
            alert("Les administrateurs ne peuvent pas s'inscrire à un événement");
            return;
        }

        submission.append("deletedProjets", JSON.stringify(deletedProjets));
        submission.append("projets", JSON.stringify(projets));
        // for (let i = 0; i < projets.length; i++) {
        //     // console.log("appending projet")
        //     // console.log(projets[i])
        //     for (let j = 0; j < projets[i].files.length; j++) {
        //         // console.log("appending file")
        //         // console.log(projets[i].files[j])
        //         submission.append("file_" + projets[i]._id + "_" + j, projets[i].files[j]);
        //     }
        // }
        submission.append("userId", props.fullUser.user._id);
        submission.append("eventId", event._id);

        api.saveSDO24popA(submission).then((response) => {
            console.log("response.data")
            console.log(response.data)
            setLoading(false);
            if (response.data === "success") {
                navigate("/thankssdo?eid=" + event._id)
            } else {
                alert("error")
            }
        });
    }

    function nextStep() {
        if (step === 1 && validateStep1()) {
            setStep(step + 1);
        }
        if (step === 2 && validateStep2()) {
            setStep(step + 1);
        }
    }

    function validateStep1() {
        const form = new FormData(formRef.current);
        return validateStep1ASDO2024(form,projets);
    }

    function validateStep2() {
        const form = new FormData(formRef.current);
        return validateStep2SDO2024(form);
    }

    if (loading) {
        return <Section className="padding"><Spinner/></Section>
    }

    return (<>
        <Header />
        <form onSubmit={submit} ref={formRef}>
            <Section className="padding" style={{ display: step === 1 ? 'block' : 'none' }}>
               <PopA1 projets={projets} setDeletedProjets={setDeletedProjets} setProjets={setProjets}/>
            </Section>
            <Section className="padding" style={{ display: step === 2 ? 'block' : 'none' }}>
                <Step2 />
            </Section>
            <Section className="padding flexblock" style={{ justifyContent: 'center', gap: '40px' }}>
                {step > 1 && <BlueButton onClick={(e) => { e.preventDefault(); setStep(step - 1) }}>{i18n.language === "fr" ? "Précédent" : "Previous"}</BlueButton>}
                {step < 2 && <BlueButton onClick={(e) => { e.preventDefault(); nextStep() }}><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Suivant" : "Next"}</BlueButton>}
                {step === 2 && <input type="submit" value={i18n.language === "fr" ? "Enregistrer" : "Save"} />}
            </Section>
        </form>
    </>)
}

export default RegisterSDO24popA;